import { useState } from "react"

import {
  CUSTOM_INSTRUCTIONS_PLACEHOLDERS,
  CustomInstructionsStep,
} from "@/components/agents/setup/custom-instructions"

import { useStepSave } from "./nav"
import type { ReviewResponderStepProps } from "./types"

function readString(data: Record<string, unknown>, key: string): string {
  const v = data[key]
  return typeof v === "string" ? v : ""
}

// IMP-373: the dedicated Custom instructions step. Reuses the existing
// additional_instructions key (already wired into the prompt builder) and the
// shared CustomInstructionsStep UI, persisting via the same useStepSave path as
// every other Review Responder step.
export function CustomizationStep({
  agent,
  stepNumber,
  totalSteps,
}: ReviewResponderStepProps) {
  const { processing, save } = useStepSave(agent.uid)
  const [instructions, setInstructions] = useState(() =>
    readString(agent.setup_data, "additional_instructions"),
  )

  const data = { additional_instructions: instructions }

  return (
    <CustomInstructionsStep
      stepNumber={stepNumber}
      totalSteps={totalSteps}
      value={instructions}
      placeholder={CUSTOM_INSTRUCTIONS_PLACEHOLDERS["review-responder"]}
      onChange={setInstructions}
      onNext={() => save("step-launch", data)}
      onBack={() => save("step-behavior", data)}
      processing={processing}
    />
  )
}
